<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('afterdeparture.Departure_UBN') }}</h5>
    <!--p class="mb-0 text-sm">{{ $t('afterdeparture.Note1Departure_to') }}</p-->
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-6">
            <div class="input-group input-group-static null">
                <label>{{ $t('afterdeparture.Departure_UBN') }}</label>
                <select
                    id="departureUbnId"
                    v-model="localFormData.departureUbnId"                    
                    class="form-control form-control-default"
                >
                    <option value="">{{ $t('afterdeparture.Select_UBN') }}</option>
                    <option
                        v-for="item in filteredDepartureUbns"
                        :key="item.id"
                        :value="item.id"
                    >
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                        {{ item.shareName ? ' - ' + item.lastName : '' }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('afterdeparture.Departure_UBN_outside_studboek') }}</label>
            <input
                v-model="localFormData.departureUbn"
                @blur="onDepartureUbnBlur"
                :disabled="isDepartureUbnIdSelected"
                type="text"
                class="form-control form-control-default"
                :placeholder="$t('afterdeparture.Departure_UBN_outside_studboek')"
            >
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('afterdeparture.Keeper_name_outside_studboek') }}</label>              
            <input
                v-model="localFormData.departureKeeper"
                @blur="onDepartureUbnBlur"
                :disabled="isDepartureUbnIdSelected"
                type="text"
                class="form-control form-control-default"
                :placeholder="$t('afterdeparture.Keeper_name_outside_studboek')"
            >
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <span v-if="wasValidated && v$.formLevel?.atLeastOneProvided?.$invalid" class="text-sm text-danger">
            {{ v$.formLevel?.atLeastOneProvided?.$message }}
          </span>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, reactive, watch, ref } from 'vue'
  import { helpers } from '@vuelidate/validators'
  import useVuelidate from '@vuelidate/core'
  import { useI18n } from 'vue-i18n'

  export default {
    name: "DepartureUbn",
    props: {
      departureubns: Array,
      exportcountries: Array,
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    computed: {    
        userRoleName() {
            return this.$store.state.user?.roleName;
        }        
    },
    setup(props, { emit }) {
      const { t } = useI18n()
      const localFormData = reactive(props.formData);

      const wasValidated = ref(false);
      
      const isDepartureUbnIdSelected = computed(() => !!localFormData.departureUbnId)

      const onDepartureUbnBlur = () => {
          if (
              localFormData.departureUbn &&
              localFormData.departureUbn.trim()
          ) {
              localFormData.departureUbnId = ''
          }
      }

      const rules = computed(() => ({

        departureUbnId: {},
        departureUbn: {},

        formLevel: {
          atLeastOneProvided: helpers.withMessage(
            t('afterdeparture.Either_studboek_UBN_or_UBN_outside_studboek_required'),
            () => {
              const hasDepartureUbnId = !!localFormData.departureUbnId
              const hasDepartureUbn = !!localFormData.departureUbn && localFormData.departureUbn.trim() !== ''

              return hasDepartureUbnId || hasDepartureUbn
            }
          )
        }
      }))

      const v$ = useVuelidate(rules, localFormData)

      const validateAndPrevStep = async () => {
        wasValidated.value = true

        await v$.value.$validate()

        if (!v$.value.$invalid) {
          props.prevStep()
        }
      }

      const validateAndNextStep = async () => {
          wasValidated.value = true

          await v$.value.$validate()

          if (!v$.value.$invalid) {
            props.nextStep()
          }
      }
      const filteredDepartureUbns = computed(() => {
          return props.departureubns.filter(
              item => item.id !== localFormData.arrivalUbnId
          )
      })
  
      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      return {
        localFormData,       
        v$,
        wasValidated,        
        isDepartureUbnIdSelected,
        filteredDepartureUbns,
        onDepartureUbnBlur,
        validateAndPrevStep,
        validateAndNextStep
      }
    }    
};
</script>
<style scoped>
.card {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
  padding: 10px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-light {
  background-color: #f9f9f9 !important;
}
.border-success {
  border-color: #28a745 !important;
}
</style>